import { DEFAULT_RULES } from '../engine/engine';

export function battleRules(fastMode: boolean) {
  return fastMode
    ? {
        ...DEFAULT_RULES,
        countdownTicks: 15,
        normalTicks: 300,
        overtimeTicks: 60,
        singleElixirPerTickMilli: 80,
        doubleElixirPerTickMilli: 160,
        tripleElixirPerTickMilli: 240,
        normalDoubleElixirStartTick: 200,
        overtimeTripleElixirStartTick: 30,
      }
    : DEFAULT_RULES;
}
